export const STATIC_HOST = 'https://universad.ru/upload/';
export const API_HOST = 'https://universad.ru/api/v1';

export const LAYOUT_DOMZNAK = 'domznak';
export const DOMAIN_DOMZNAK = 'домзнак-универсад.рф';

export const LAYOUT_SADSERVICE = 'sadservice';
export const DOMAIN_SADSERVICE = 'садсервис.рф';